module.exports = __webpack_public_path__ + "static/media/14.11.32e33fb0.jpg";